import { MinimalFooterSocialLinks } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  MinimalFooterSocialLinks,
  PropTableValues,
  React
};